var _slicedToArray = require("/builds/client-projects/fert-demolition-motos-website/application/node_modules/@babel/runtime/helpers/slicedToArray.js").default;

var _toConsumableArray = require("/builds/client-projects/fert-demolition-motos-website/application/node_modules/@babel/runtime/helpers/toConsumableArray.js").default;

var _defineProperty = require("/builds/client-projects/fert-demolition-motos-website/application/node_modules/@babel/runtime/helpers/defineProperty.js").default;

var _objectSpread = require("/builds/client-projects/fert-demolition-motos-website/application/node_modules/@babel/runtime/helpers/objectSpread2.js").default;

var _createForOfIteratorHelper = require("/builds/client-projects/fert-demolition-motos-website/application/node_modules/@babel/runtime/helpers/createForOfIteratorHelper.js").default;

!function webpackUniversalModuleDefinition(e, t) {
  "object" == typeof exports && "object" == typeof module ? module.exports = t() : "function" == typeof define && define.amd ? define([], t) : "object" == typeof exports ? exports["@wordpress/keyboard-shortcuts"] = t() : (e.wp = e.wp || {}, e.wp.keyboardShortcuts = t());
}(self, function () {
  return function () {
    var e = {
      221: function _(e) {
        function _extends() {
          return e.exports = _extends = Object.assign || function (e) {
            for (var t = 1; t < arguments.length; t++) {
              var r = arguments[t];

              for (var n in r) {
                Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
              }
            }

            return e;
          }, e.exports.__esModule = !0, e.exports.default = e.exports, _extends.apply(this, arguments);
        }

        e.exports = _extends, e.exports.__esModule = !0, e.exports.default = e.exports;
      },
      424: function _(e) {
        e.exports = function _interopRequireDefault(e) {
          return e && e.__esModule ? e : {
            default: e
          };
        }, e.exports.__esModule = !0, e.exports.default = e.exports;
      },
      657: function _(e, t, r) {
        "use strict";

        var n = r(424);
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.ShortcutProvider = function ShortcutProvider(e) {
          var t = (0, o.useRef)(new Set());
          return (0, o.createElement)(i, {
            value: t
          }, (0, o.createElement)("div", (0, a.default)({}, e, {
            onKeyDown: function onKeyDown(r) {
              e.onKeyDown && e.onKeyDown(r);

              var _iterator = _createForOfIteratorHelper(t.current),
                  _step;

              try {
                for (_iterator.s(); !(_step = _iterator.n()).done;) {
                  var _e = _step.value;

                  _e(r);
                }
              } catch (err) {
                _iterator.e(err);
              } finally {
                _iterator.f();
              }
            }
          })));
        };
        var o = r(753),
            a = n(r(221)),
            u = r(317);
        var i = u.context.Provider;
      },
      317: function _(e, t, r) {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.context = void 0;
        var n = (0, r(753).createContext)();
        t.context = n;
      },
      77: function _(e, t, r) {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.default = function useShortcutEventMatch() {
          var _ref = (0, n.useSelect)(a.store),
              e = _ref.getAllShortcutKeyCombinations;

          return function isMatch(t, r) {
            return e(t).some(function (e) {
              var t = e.modifier,
                  n = e.character;
              return o.isKeyboardEvent[t](r, n);
            });
          };
        };
        var n = r(467),
            o = r(880),
            a = r(437);
      },
      256: function _(e, t, r) {
        "use strict";

        var n = r(424);
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.default = function useShortcut(e, t) {
          var _ref2 = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
              r = _ref2.isDisabled;

          var n = (0, o.useContext)(u.context),
              i = (0, a.default)(),
              c = (0, o.useRef)();
          c.current = t, (0, o.useEffect)(function () {
            if (!r) return n.current.add(_callback), function () {
              n.current.delete(_callback);
            };

            function _callback(t) {
              i(e, t) && c.current(t);
            }
          }, [e, r]);
        };
        var o = r(753),
            a = n(r(77)),
            u = r(317);
      },
      224: function _(e, t) {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.registerShortcut = function registerShortcut(e) {
          var t = e.name,
              r = e.category,
              n = e.description,
              o = e.keyCombination,
              a = e.aliases;
          return {
            type: "REGISTER_SHORTCUT",
            name: t,
            category: r,
            keyCombination: o,
            aliases: a,
            description: n
          };
        }, t.unregisterShortcut = function unregisterShortcut(e) {
          return {
            type: "UNREGISTER_SHORTCUT",
            name: e
          };
        };
      },
      437: function _(e, t, r) {
        "use strict";

        var n = r(424);
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.store = void 0;

        var o = r(467),
            a = n(r(958)),
            u = _interopRequireWildcard(r(224)),
            i = _interopRequireWildcard(r(176));

        function _getRequireWildcardCache(e) {
          if ("function" != typeof WeakMap) return null;
          var t = new WeakMap(),
              r = new WeakMap();
          return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
            return e ? r : t;
          })(e);
        }

        function _interopRequireWildcard(e, t) {
          if (!t && e && e.__esModule) return e;
          if (null === e || "object" != typeof e && "function" != typeof e) return {
            default: e
          };

          var r = _getRequireWildcardCache(t);

          if (r && r.has(e)) return r.get(e);
          var n = {},
              o = Object.defineProperty && Object.getOwnPropertyDescriptor;

          for (var a in e) {
            if ("default" !== a && Object.prototype.hasOwnProperty.call(e, a)) {
              var u = o ? Object.getOwnPropertyDescriptor(e, a) : null;
              u && (u.get || u.set) ? Object.defineProperty(n, a, u) : n[a] = e[a];
            }
          }

          return n.default = e, r && r.set(e, n), n;
        }

        var c = (0, o.createReduxStore)("core/keyboard-shortcuts", {
          reducer: a.default,
          actions: u,
          selectors: i
        });
        t.store = c, (0, o.register)(c);
      },
      958: function _(e, t, r) {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.default = void 0;
        var n = r(793);

        var o = function reducer() {
          var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
              t = arguments.length > 1 ? arguments[1] : void 0;

          switch (t.type) {
            case "REGISTER_SHORTCUT":
              return _objectSpread(_objectSpread({}, e), {}, _defineProperty({}, t.name, {
                category: t.category,
                keyCombination: t.keyCombination,
                aliases: t.aliases,
                description: t.description
              }));

            case "UNREGISTER_SHORTCUT":
              return (0, n.omit)(e, t.name);
          }

          return e;
        };

        t.default = o;
      },
      176: function _(e, t, r) {
        "use strict";

        var n = r(424);
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.getCategoryShortcuts = t.getAllShortcutRawKeyCombinations = t.getAllShortcutKeyCombinations = void 0, t.getShortcutAliases = getShortcutAliases, t.getShortcutDescription = function getShortcutDescription(e, t) {
          return e[t] ? e[t].description : null;
        }, t.getShortcutKeyCombination = getShortcutKeyCombination, t.getShortcutRepresentation = function getShortcutRepresentation(e, t) {
          var r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : "display";
          var n = getShortcutKeyCombination(e, t);
          return getKeyCombinationRepresentation(n, r);
        };
        var o = n(r(235)),
            a = r(793),
            u = r(880);
        var i = [],
            c = {
          display: u.displayShortcut,
          raw: u.rawShortcut,
          ariaLabel: u.shortcutAriaLabel
        };

        function getKeyCombinationRepresentation(e, t) {
          return e ? e.modifier ? c[t][e.modifier](e.character) : e.character : null;
        }

        function getShortcutKeyCombination(e, t) {
          return e[t] ? e[t].keyCombination : null;
        }

        function getShortcutAliases(e, t) {
          return e[t] && e[t].aliases ? e[t].aliases : i;
        }

        var s = (0, o.default)(function (e, t) {
          return (0, a.compact)([getShortcutKeyCombination(e, t)].concat(_toConsumableArray(getShortcutAliases(e, t))));
        }, function (e, t) {
          return [e[t]];
        });
        t.getAllShortcutKeyCombinations = s;
        var l = (0, o.default)(function (e, t) {
          return s(e, t).map(function (e) {
            return getKeyCombinationRepresentation(e, "raw");
          });
        }, function (e, t) {
          return [e[t]];
        });
        t.getAllShortcutRawKeyCombinations = l;
        var d = (0, o.default)(function (e, t) {
          return Object.entries(e).filter(function (e) {
            var _e2 = _slicedToArray(e, 2),
                r = _e2[1];

            return r.category === t;
          }).map(function (e) {
            var _e3 = _slicedToArray(e, 1),
                t = _e3[0];

            return t;
          });
        }, function (e) {
          return [e];
        });
        t.getCategoryShortcuts = d;
      },
      235: function _(e, t, r) {
        "use strict";

        var n, o;

        function arrayOf(e) {
          return [e];
        }

        function createCache() {
          var e = {
            clear: function clear() {
              e.head = null;
            }
          };
          return e;
        }

        function isShallowEqual(e, t, r) {
          var n;
          if (e.length !== t.length) return !1;

          for (n = r; n < e.length; n++) {
            if (e[n] !== t[n]) return !1;
          }

          return !0;
        }

        function __WEBPACK_DEFAULT_EXPORT__(e, t) {
          var r, a;

          function clear() {
            r = o ? new WeakMap() : createCache();
          }

          function callSelector() {
            var r,
                n,
                o,
                u,
                i,
                c = arguments.length;

            for (u = new Array(c), o = 0; o < c; o++) {
              u[o] = arguments[o];
            }

            for (i = t.apply(null, u), (r = a(i)).isUniqueByDependants || (r.lastDependants && !isShallowEqual(i, r.lastDependants, 0) && r.clear(), r.lastDependants = i), n = r.head; n;) {
              if (isShallowEqual(n.args, u, 1)) return n !== r.head && (n.prev.next = n.next, n.next && (n.next.prev = n.prev), n.next = r.head, n.prev = null, r.head.prev = n, r.head = n), n.val;
              n = n.next;
            }

            return n = {
              val: e.apply(null, u)
            }, u[0] = null, n.args = u, r.head && (r.head.prev = n, n.next = r.head), r.head = n, n.val;
          }

          return t || (t = arrayOf), a = o ? function getWeakMapCache(e) {
            var t,
                o,
                a,
                u,
                i,
                c = r,
                s = !0;

            for (t = 0; t < e.length; t++) {
              if (o = e[t], !(i = o) || "object" != typeof i) {
                s = !1;
                break;
              }

              c.has(o) ? c = c.get(o) : (a = new WeakMap(), c.set(o, a), c = a);
            }

            return c.has(n) || ((u = createCache()).isUniqueByDependants = s, c.set(n, u)), c.get(n);
          } : function getRootCache() {
            return r;
          }, callSelector.getDependants = t, callSelector.clear = clear, clear(), callSelector;
        }

        r.r(t), r.d(t, {
          default: function _default() {
            return __WEBPACK_DEFAULT_EXPORT__;
          }
        }), n = {}, o = "undefined" != typeof WeakMap;
      },
      467: function _(e) {
        "use strict";

        e.exports = require("@wordpress/data");
      },
      753: function _(e) {
        "use strict";

        e.exports = require("@wordpress/element");
      },
      880: function _(e) {
        "use strict";

        e.exports = require("@wordpress/keycodes");
      },
      793: function _(e) {
        "use strict";

        e.exports = require("lodash");
      }
    },
        t = {};

    function __webpack_require__(r) {
      var n = t[r];
      if (void 0 !== n) return n.exports;
      var o = t[r] = {
        exports: {}
      };
      return e[r](o, o.exports, __webpack_require__), o.exports;
    }

    __webpack_require__.d = function (e, t) {
      for (var r in t) {
        __webpack_require__.o(t, r) && !__webpack_require__.o(e, r) && Object.defineProperty(e, r, {
          enumerable: !0,
          get: t[r]
        });
      }
    }, __webpack_require__.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, __webpack_require__.r = function (e) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      });
    };
    var r = {};
    return function () {
      "use strict";

      var e = r,
          t = __webpack_require__(424);

      Object.defineProperty(e, "__esModule", {
        value: !0
      }), Object.defineProperty(e, "ShortcutProvider", {
        enumerable: !0,
        get: function get() {
          return a.ShortcutProvider;
        }
      }), Object.defineProperty(e, "__unstableUseShortcutEventMatch", {
        enumerable: !0,
        get: function get() {
          return u.default;
        }
      }), Object.defineProperty(e, "store", {
        enumerable: !0,
        get: function get() {
          return n.store;
        }
      }), Object.defineProperty(e, "useShortcut", {
        enumerable: !0,
        get: function get() {
          return o.default;
        }
      });

      var n = __webpack_require__(437),
          o = t(__webpack_require__(256)),
          a = __webpack_require__(657),
          u = t(__webpack_require__(77));
    }(), r;
  }();
});